import React, { Component, useState } from 'react';
import './Home.css';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';



export default function Home() {

   const [traslate, i18n] = useTranslation("home");

   const [img1, setImg1] = useState("/izquierda.jpg");
   const [img2, setImg2] = useState("/derecha.jpg");
   const [titulo1, setTitulo1] = useState(traslate("obras1.titulo1"));
   const [titulo2, setTitulo2] = useState(traslate("obras1.titulo2"));
   const [medidas1, setMedidas1] = useState(traslate("obras1.medidas1"));
   const [medidas2, setMedidas2] = useState(traslate("obras1.medidas2"));
   const [tecnica1, setTecnica1] = useState(traslate("obras1.tecnica1"));
   const [tecnica2, setTecnica2] = useState(traslate("obras1.tecnica2"));
   const [toolTipGaleria1, setToolTipGaleria1] = useState(traslate("toolTipGaleria.toolTip1"));
   const [toolTipGaleria2, setToolTipGaleria2] = useState(traslate("toolTipGaleria.toolTip2"));


   const [count, setCount] = useState(0);

   let counter = 0;


   React.useEffect(() => {
      setInterval(() => {
         setCount(counter = counter + 1);

         if (counter > 12) {
            setCount(counter = 1);
         }

         if (counter < 4) {
            setImg1("/izquierda.jpg");
            setImg2("/derecha.jpg");
            setTitulo1(traslate("obras1.titulo1"));
            setTitulo2(traslate("obras1.titulo2"));
            setMedidas1(traslate("obras1.medidas1"));
            setMedidas2(traslate("obras1.medidas2"));
            setTecnica1(traslate("obras1.tecnica1"));
            setTecnica2(traslate("obras1.tecnica2"));

         } else if (counter > 4 && counter < 8) {
            setImg1("/3.jpg");
            setImg2("/4.jpg");
            setTitulo1(traslate("obras2.titulo1"));
            setTitulo2(traslate("obras2.titulo2"));
            setMedidas1(traslate("obras2.medidas1"));
            setMedidas2(traslate("obras2.medidas2"));
            setTecnica2(traslate("obras2.tecnica2"));
            setTecnica1(traslate("obras2.tecnica1"));
         } else if (counter > 8) {
            setImg1("/5.jpg");
            setImg2("/6.jpg");
            setTitulo1(traslate("obras3.titulo1"));
            setTitulo2(traslate("obras3.titulo2"));
            setMedidas1(traslate("obras3.medidas1"));
            setMedidas2(traslate("obras3.medidas2"));
            setTecnica1(traslate("obras3.tecnica1"));
            setTecnica2(traslate("obras3.tecnica2"));
         }
         console.log(counter);

      }, 1000);
   }, [])

   return (

      <div className='Home'>
         <div className='portada '>
            <img src={process.env.PUBLIC_URL + '/HOMEDOS.jpg'} width='100%' />
         </div>
         <div className='constante'>
            <h1>{traslate("header.constante")}</h1>
         </div>
         <div className='plastica'>
            <a href="https://inba.gob.mx/recinto/27">
               <img src={process.env.PUBLIC_URL + '/salonPlasticaMexicana-9fdd5cff.png'}></img>
            </a>
            <p>{traslate("header.plastica")}</p>
         </div>


         <div className='seccion-fichas-tecnicas'>
            <div className='row px-2 fichas-tecnicas'>
               <div className="col-6 col-md-6 col-lg-3">
                  <div className='ficha p-4'>
                     <p className='mt-3'>Rafael Merinoo</p>
                     <p className='my-1'> {titulo1}</p>
                     <p className='my-1'>{medidas1}</p>
                     <p className='my-1'>{tecnica1}</p>
                  </div>
               </div>
               <div className='col-6 col-md-6 col-lg-3 d-flex justify-content-center'>
                  <img className='contorno' src={process.env.PUBLIC_URL + img1}></img>
               </div>

               <div className='col-6 col-md-6 col-lg-3 d-flex justify-content-center ficha-dos'>
                  <img className='contorno' src={process.env.PUBLIC_URL + img2}></img>
               </div>
               <div className='col-6 col-md-6 col-lg-3 d-flex justify-content-end ficha-dos'>
                  <div className='ficha p-4'>
                     <p className='mt-3'>Rafael Merinoo</p>
                     <p className='my-1'>{titulo2}</p>
                     <p className='my-1'>{medidas2}</p>
                     <p className='my-1'>{tecnica2}</p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
